// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-avatar--item{border-radius:4px !important}.v-badge__badge{height:12px !important;width:12px !important;right:-15px !important}\n", ""]);
// Exports
module.exports = exports;
